import { render } from "./ListeAnneeAcademique.vue?vue&type=template&id=2332e8c8&ts=true"
import script from "./ListeAnneeAcademique.vue?vue&type=script&lang=ts"
export * from "./ListeAnneeAcademique.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__